



































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import ImageUploader from '../../files/_components/imageUploader.vue';
import DatePicker from '../../../components/date-picker.vue';

@Component({
  components: {
    DatePicker,
    ImageUploader,
  },
  props: {
    active: Boolean,
    press: Object,
  },
})
export default class DlgPressEdit extends Vue {
  public $refs!: {
    image: any,
    form: any,
    file: any,
  };

  private dialog: boolean = false;
  private valid: boolean = true;
  private loading: boolean = false;
  private localPress: any = {};
  private file: any = {};
  private selectedFile: any;
  private fileName: any = '';
  private radio: number = 0;

  @Action('press/update') private pressUpdate!: any;
  @Action('press/read') private pressGetAll!: any;
  @Action('press/uploadFile') private uploadFile!: any;
  @Getter('rules/all') private rules!: any;


  private selectFile() {
    if (this.loading) {
      return;
    }
    this.$refs.file.click();
  }

  private onFilePicked(e: any) {
    const {files} = e.target;
    if (files[0] !== undefined) {
      this.fileName = files[0].name;
      if (!this.file.title) {
        this.file.name = files[0].name;
      }

      this.selectedFile = files[0];
    }
  }

  @Watch('active')
  private onContentChanged(newVal: boolean, oldVal: boolean) {
    this.dialog = newVal;

    if (newVal) {
      this.localPress = JSON.parse(JSON.stringify(this.$props.press));
      this.fileName = '-- unverändert --';
    }
  }

  private async update() {
    this.localPress.title = this.localPress.title.trim();
    this.localPress.pressDate = this.localPress.pressDate.trim();

    if (!this.$refs.form.validate()) {
      return;
    }

    this.loading = true;

    if (this.radio === 1 && this.selectedFile) {
      this.localPress.webUrl = await this.uploadFile(this.selectedFile);
      this.localPress.webUrl = `https://files.ihrespezialisten.at/${this.localPress.webUrl}`;
    }

    if (this.localPress.imageUrl !== this.$props.press.imageUrl) {
      this.localPress.imageUrl = await this.$refs.image.doUpload();
    }
    const success = await this.pressUpdate(this.localPress);

    if (success) {
      this.$emit('close');
      this.dialog = false;

      this.localPress = {};
      this.$refs.image.reset();
      this.$refs.form.reset();
      await this.pressGetAll();
      this.radio = 0;
    }

    this.loading = false;
  }

  private async close() {
    this.$emit('close');
  }
}
